.root {
    position: relative;
    padding-block: var(--spacer-120);
    container-type: inline-size;
}

.oops {
    opacity: 0.15;
    font-weight: 600;
    font-family: Poppins, sans-serif;
    fill: var(--color-contrast);
    font-size: 37vw;
    font-size: 37cqw;
    letter-spacing: -0.04em;
    line-height: 1;
}

.content {
    position: absolute;
    bottom: var(--spacer-120);
    inset-inline: 0;
    text-align: center;
}
